import * as Cookie from "js-cookie";

export const DisplayNewUIComponent: boolean = Cookie.get("ff-UxUpdate") === "1";
